"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../shared/controllers/BaseController");
var DlgSetPProgramPartnerOfferCtl = /** @class */ (function (_super) {
    __extends(DlgSetPProgramPartnerOfferCtl, _super);
    function DlgSetPProgramPartnerOfferCtl() {
        return _super.call(this, true) || this;
    }
    DlgSetPProgramPartnerOfferCtl.prototype.ResetData = function () {
        this.DATA = {
            onYes: null,
            dialogTitle: "",
            visible: false,
            // pprogramId: 0,
            // pprogramTitle: "",
            // pprogramsAvail: [],
            // offerId: 0,
            // offerTitle: "",
            // offersAvail: [],
            // partnerId: 0,
            // partnerLogin: "",
            // partnersAvail: [],
            onNo: null
        };
    };
    DlgSetPProgramPartnerOfferCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgSetPProgramPartnerOfferCtl.prototype.clearFields = function () {
        this.ResetData();
        return this;
    };
    DlgSetPProgramPartnerOfferCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgSetPProgramPartnerOfferCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    DlgSetPProgramPartnerOfferCtl.prototype.SetOnYesClick = function (callback, forceUpdate) {
        this.DATA.onYes = callback;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSetPProgramPartnerOfferCtl.prototype.GetOnYesClick = function () {
        return this.DATA.onYes;
    };
    DlgSetPProgramPartnerOfferCtl.prototype.SetOnNoClick = function (callback, forceUpdate) {
        this.DATA.onNo = callback;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSetPProgramPartnerOfferCtl.prototype.GetOnNoClick = function () {
        return this.DATA.onNo;
    };
    DlgSetPProgramPartnerOfferCtl.prototype.SetDialogTitle = function (title, forceUpdate) {
        this.DATA.dialogTitle = title;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSetPProgramPartnerOfferCtl.prototype.GetDialogTitle = function () {
        return this.DATA.dialogTitle;
    };
    return DlgSetPProgramPartnerOfferCtl;
}(BaseController_1.BaseController));
exports.DlgSetPProgramPartnerOfferCtl = DlgSetPProgramPartnerOfferCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ctl/DlgSetPProgramPartnerOfferCtl.ts
// module id = 910
// module chunks = 0